var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.57 20.96c.07.03.14.04.21.04.24 0 .46-.15.56-.39l6.45-16.8a.615.615 0 00-.35-.78c-.3-.11-.65.04-.77.35l-6.45 16.8c-.11.31.04.66.35.78zM7 18c-.15 0-.31-.06-.42-.18l-5.4-5.4a.61.61 0 010-.85l5.4-5.4a.61.61 0 01.85 0c.23.23.23.61 0 .85L2.45 12l4.98 4.98c.23.23.23.61 0 .85A.65.65 0 017 18zm10 0c-.15 0-.31-.06-.42-.18a.61.61 0 010-.85L21.55 12l-4.98-4.98a.61.61 0 010-.85.61.61 0 01.85 0l5.4 5.4c.23.23.23.61 0 .85l-5.4 5.4c-.11.12-.27.18-.42.18z"
  })));
}

export default SvgCode;